import {createApp, ref} from 'vue';
import {connectVue} from '@/modules/configureBugsnag';
import configureGlobalComponents from '../modules/configureGlobalComponents';
import sendAnalyticsEvent from '../modules/sendAnalyticsEvent';
import useVuelidate from '@vuelidate/core';
import {helpers, required} from '@vuelidate/validators';
import {vrm} from '@/modules/regitValidators';

const app = createApp({
    setup() {
        const state = {
            vrm: ref(''),
        };

        const rules = {
            vrm: {
                required: helpers.withMessage('Please enter your reg plate', required),
                vrm: helpers.withMessage('Please enter a valid reg', vrm),
            },
        };

        const v = useVuelidate(rules, state);
        async function submit(e: Event) {
            e.preventDefault();
            e.stopPropagation();

            const validationPassed = await v.value.$validate();
            if (validationPassed) {
                sendAnalyticsEvent('Conversion Tracking', 'ULEZ', 'VRM');
                (document.getElementById('ulez-landing-form') as HTMLFormElement).submit();
            }
        }

        return {
            vrm: state.vrm,
            v$: v,
            submit,
        };
    },
    mounted() {
        sendAnalyticsEvent('Conversion Tracking', 'ULEZ', 'Landing');
    },
});

connectVue(app);
configureGlobalComponents(app);
app.mount('#app');
